module.exports = __webpack_public_path__ + "static/media/project-health.dc9a8758.jpg";